import type { ActivationCounts, DirectorySync } from "./types";

/** Activation has been read from Workvivo at least once (otherwise hide activation numbers rather than show 0%). */
export function isActivationChecked(sync?: DirectorySync | null): boolean {
  return Boolean(sync?.finished_at);
}

/** Whole-number percentage of `part` in `base`; null when `base` is 0 (nothing to compare against). */
export function activationPercent(part: number, base: number): number | null {
  if (!Number.isFinite(base) || base <= 0) return null;
  return Math.round((Math.max(0, part) / base) * 100);
}

/** Percentage of active people who have logged in to Workvivo (the donut's centre number). */
export function activatedShare(counts: ActivationCounts): number | null {
  return activationPercent(counts.activated, counts.active);
}

/** "42 of 57 active people have logged in to Workvivo" */
export function activationHeadline(counts: ActivationCounts): string {
  if (counts.active <= 0) return "No active users to check yet";
  const noun = counts.active === 1 ? "active person has" : "active people have";
  return `${counts.activated} of ${counts.active} ${noun} logged in to Workvivo`;
}

/** Screen-reader summary of the donut. */
export function activationAriaLabel(counts: ActivationCounts): string {
  const pct = activatedShare(counts);
  if (pct === null) return "Workvivo logins: no active users";
  const parts = [`${counts.not_activated} not logged in yet`];
  if (counts.unknown > 0) parts.push(`${counts.unknown} unknown`);
  return `Workvivo logins: ${activationHeadline(counts)} (${pct}%). ${parts.join(", ")}.`;
}
